<template>
  <div>
    
    <v-stepper class="ma-5" v-model="currentElement" :vertical="vertical">
      <v-row class="ma-5">
        <v-col cols="12" md="6">
        <h3 v-if="is_editing" class="text-left">
          Admission Progress: {{ admission_details.admission_unique_id }}
        </h3>
        <h3 v-else class="text-left">New Admission</h3>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="10" md="4" >
          <v-chip
          outlined
          v-if="is_editing"
          :color="admission_details.is_terminated ? 'red' : 'primary'"
        >
          <h4>{{ admission_details.current_status }}</h4>
        </v-chip>
        </v-col>
        <v-col cols="2" md="1" v-if="admission_details.status == 5">
          <v-icon large color="primary">mdi-check</v-icon>
        </v-col>
      </v-row>

      <v-speed-dial
        v-model="fab"
        bottom
        right
        class="mx-4"
        direction="top"
        open-on-hover
        v-if="is_editing"
        fixed
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab"
          color="blue darken-2"
          dark
          x-large
          fab
        >
          <v-icon large v-if="fab">
            mdi-close
          </v-icon>
          <v-icon large v-else>
            mdi-card-account-phone
          </v-icon>
        </v-btn>
      </template>
      <v-btn
        fab
        dark
        large
        color="green"
        target="_blank"
        :href="admission_details.application_details ? `https://wa.me/91${admission_details.application_details.mobileno}` : `https://wa.me/91${admission_details.enquiry_details.mobileno}`"

      >
        <v-icon large>mdi-whatsapp</v-icon>
      </v-btn>
      <v-btn
        fab
        dark
        large
        color="indigo"
        :href="admission_details.application_details ? ` tel:${admission_details.application_details.mobileno}` : `tel:${admission_details.enquiry_details.mobileno}`"
      >
        <v-icon>mdi-phone</v-icon>
      </v-btn>
      <v-btn
        fab
        dark
        large
        color="red"
        :href="admission_details.application_details ? ` mailto:${admission_details.application_details.email}` : `mailto:${admission_details.enquiry_details.email}`"
      >
        <v-icon large>mdi-email</v-icon>
      </v-btn>
    </v-speed-dial>
     
      <template v-if="vertical">
        <template v-for="item in items">
          <v-stepper-step
            :key="`${item.id}-step`"
            :complete="isComplete(item)"
            :step="item.id"
            :editable="isEditable(item)"
          >
            <h4>{{ item.tab }}</h4>
          </v-stepper-step>

          <v-stepper-content :key="`${item.id}-content`" :step="item.id">
            <v-card elevation="0">
              <component
                v-bind:is="item.content"
                v-bind="currentProperties"
                @form-change="formChange"
                @save-response="saveResponse"
                :ref="('form-' + item.id)"
              ></component>
            </v-card>

            <v-btn
              text
              color="error"
              outlined
              class="ma-2"
              @click="showTerminateDialog"
              v-if="is_editing && !admission_details.is_terminated && admission_details.student_details==null && currentUser.privileges.canTerminateAdmissions"
            >
              Terminate Admission</v-btn
            >
            <v-btn
              color="primary"
              class="ma-2"
              v-if="canSave(item)"
              :disabled="!item.is_form_valid || admission_details.student_details!=null || isLoading"
              @click="saveForm(item)"
            >
              {{ item.id == 5 ? 'Confirm Admission' : 'Save Details' }}
            </v-btn>
            <v-tooltip 
              bottom 
              v-if="is_editing && !admission_details.is_terminated && canUnlock(item)"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  class="ma-2"
                  @click="unlockNext"
                  v-bind="attrs"
                  v-on="on"
                >
                  Unlock {{ findNextItemTabName(item) }}
                </v-btn>
              </template>
              <span>This will unlock {{findNextItemTabName(item)}} step.</span>
            </v-tooltip>
            
            <v-btn
              color="primary"
              class="ma-2"
              v-else-if="is_editing && !admission_details.is_terminated && canLock(item)"
              @click="lockNext"
            >
              Lock {{ findNextItemTabName(item) }}
            </v-btn>
            <span v-else></span>
            
            <!-- Always disabled, for some ugly DOM manipulation -->
            <!-- <v-btn
              color="primary"
              class="ma-2"
              v-else
              :disabled="true"
            >
              Save Details
            </v-btn> -->
            <v-btn color="primary" class="ma-2" v-if="admission_details.is_terminated" @click="showRestoreDialog" >
              Restore from Termination
            </v-btn>
          </v-stepper-content>
        </template>
      </template>
    </v-stepper>
    <TerminationConfirmationDialog
      ref="xyz"
      title="Are you sure you want to terminate this admission?"
      :visible="showTerminateConfirmation"
      @deleteObject="terminateAdmissionConfirmation"
      confirmationButtonText="Terminate"
    />
    <RestorationConfirmationDialog
      title="Are you sure you want to restore this admission?"
      :visible="showRestoreConfirmation"
      @deleteObject="restoreAdmissionConfirmation"
      confirmationButtonText="Restore"
    />
    <v-snackbar v-model="snackbar.visible">
      {{ snackbar.text }}
      <template>
        <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import EnquiryStepperContent from "@components/admission/admissiondetails/EnquiryStepperContent";
import ApplicationStepperContent from "@components/admission/admissiondetails/ApplicationStepperContent";
import UploadedDocumentsStepperContent from "@components/admission/admissiondetails/UploadedDocumentsStepperContent";
import EvaluationStepperContent from "@components/admission/admissiondetails/EvaluationStepperContent";
import ConfirmationStepperContent from "@components/admission/admissiondetails/ConfirmationStepperContent";
import { mapActions, mapGetters } from "vuex";
import api from "@api/index";
import endpoints from "@api/repository";
import DeleteConfirmationDialog from "@components/widgets/dialogs/DeleteConfirmationDialog";

export default {
  name: "AddEditAdmissionDetails",
  components: {
    EnquiryStepperContent: EnquiryStepperContent,
    ApplicationStepperContent: ApplicationStepperContent,
    UploadedDocumentsStepperContent: UploadedDocumentsStepperContent,
    EvaluationStepperContent: EvaluationStepperContent,
    ConfirmationStepperContent: ConfirmationStepperContent,
    TerminationConfirmationDialog: DeleteConfirmationDialog,
    RestorationConfirmationDialog: DeleteConfirmationDialog,
  },
  data() {
    return {
      is_editing: false,
      currentElement: 1,
      steps: 5,
      vertical: true,
      fab: false,
      editable: true,
      admission_id: null,
      items: [
        {
          id: 1,
          tab: "Enquiry",
          content: EnquiryStepperContent,
          is_form_valid: false,
        },
        {
          id: 2,
          tab: "Application",
          content: ApplicationStepperContent,
          is_form_valid: false,
        },
        {
          id: 3,
          tab: "Uploaded Documents",
          content: UploadedDocumentsStepperContent,
          is_form_valid: false,
        },
        {
          id: 4,
          tab: "Evaluation",
          content: EvaluationStepperContent,
          is_form_valid: true,
        },
        {
          id: 5,
          tab: "Confirmation",
          content: ConfirmationStepperContent,
          is_form_valid: false,
        },
      ],
      stepHeaders: [
        "Enquiry",
        "Application",
        "Uploaded Documents",
        "Evaluation",
        "Confirmation",
      ],
      stepContent: [
        "EnquiryStepperContent",
        "ApplicationStepperContent",
        "UploadedDocumentsStepperContent",
        "EvaluationStepperContent",
        "ConfirmationStepperContent",
      ],
      admission_details: {
        enquiry_details: {
          class_standard: {
            academic_session: {
              title: null,
            },
          },
          source: null,
          enquiry_date: new Date().toISOString().split('T')[0],
        },
        application_details: {
          profile_pic: null,
        },
        admission_docs: {},
        is_terminated: false,
        is_from_portal: false,
      },
      class_standards: [],
      enquirySources: [],
      doctypes: [],
      showTerminateConfirmation: false,
      showRestoreConfirmation: false,
      snackbar: {
        visible: false,
        text: "",
      },
      enquiryForm: false,
    };
  },
  computed: {
    ...mapGetters(["accessToken", "currentUser","isLoading"]),
    apiEssentials() {
      return {
        accessToken: this.accessToken,
        handleErrorsFunction: this.handleApiErrors,
        setLoading: this.setLoading,
      };
    },

    currentProperties: function () {
      var currentProps = {};
      switch (this.currentElement) {
        case 1:
          currentProps = {
            enquiryDetails: this.admission_details.enquiry_details,
            is_terminated: this.admission_details.is_terminated,
            class_standards: this.class_standards,
            enquirySources: this.enquirySources,
            is_editing: this.is_editing,
            admission_id: this.is_editing? this.admission_details.id: null,
            is_from_portal: this.admission_details.is_from_portal,
          };
          break;
        case 2:
          currentProps = {
            class_standards: this.class_standards,
            is_terminated: this.admission_details.is_terminated,
            admission_id: this.is_editing? this.admission_details.id: null,
            enquiryDetails: this.admission_details.enquiry_details,
            is_from_portal: this.admission_details.is_from_portal,
          };
          if(this.admission_details.application_details != null){
            currentProps['applicationDetails'] = this.admission_details.application_details;
            currentProps['is_editing'] = true;
          }
          break;
        case 3:
          currentProps = { 
            is_terminated: this.admission_details.is_terminated,
            doctypes: this.doctypes,
            admission_id: this.is_editing? this.admission_details.id: null,
            is_from_portal: this.admission_details.is_from_portal,
          };
          if(this.admission_details.admission_docs.length > 0){
            currentProps['admissionDocs'] = this.admission_details.admission_docs;
            currentProps['is_editing'] = true;
          }
          break;
        case 4:
          currentProps = {
            is_terminated: this.admission_details.is_terminated,
            admission_id: this.is_editing? this.admission_details.id: null,
            admissionDetails: this.admission_details,
            class_standards: this.class_standards,
            doctypes: this.doctypes,
            is_from_portal: this.admission_details.is_from_portal,
          }
          break;
        case 5: 
          currentProps = {
            admissionDetails: this.admission_details,
            is_from_portal: this.admission_details.is_from_portal,
          }
          if(this.admission_details.student_details!=null){
            currentProps['readonly'] = true
            currentProps['userDetails'] = this.admission_details.student_details
          }
          break;
      }
      return currentProps;
    },
  },
  async mounted(){
    
  },
  methods: {
    ...mapActions(["setLoading"]),

    isComplete(item) {
      return (
        item.id < this.admission_details.status ||
        (item.id <= this.admission_details.status &&
          this.admission_details.unlock_for_next)
      );
    },

    isEditable(item) {
      return (
        item.id <= this.admission_details.status ||
        (item.id == this.admission_details.status + 1 &&
          this.admission_details.unlock_for_next)
      );
    },

    saveForm(item){
      var ref_name = `form-${item.id}`;
      // console.log("SAVE",ref_name);
      (this.$refs[ref_name][0]).saveFormDetails();
    },

    canSave(item) {
      if(item.id == 1 && !this.currentUser.privileges.canEditOwnEnquiries) return false;
      if(item.id == 2 && !this.currentUser.privileges.canEditApplications) return false;
      if(item.id == 3 && !this.currentUser.privileges.canEditUploadedDocuments) return false;
      if(item.id == 4 && !this.currentUser.privileges.canEvaluateAdmissions) return false;
      if(item.id == 5 && !this.currentUser.privileges.canConfirmAdmissions) return false;
      return true;
    },

    canUnlock(item){
      if(item.id == 1 && !this.currentUser.privileges.canUnlockApplications) return false;
      if(item.id == 2 && !this.currentUser.privileges.canUnlockUploadedDocuments) return false;
      if(item.id == 3 && !this.currentUser.privileges.canEvaluateAdmissions) return false;
      if(item.id == 4 && !this.currentUser.privileges.canUnlockConfirmation) return false;
      // can only unlock if next is locked and status is currentElement
      return (this.admission_details.status < 5) && !this.admission_details.unlock_for_next && item.id == this.admission_details.status;
    },

    canLock(item){
      if(item.id == 1 && !this.currentUser.privileges.canUnlockApplications) return false;
      if(item.id == 2 && !this.currentUser.privileges.canUnlockUploadedDocuments) return false;
      if(item.id == 3 && !this.currentUser.privileges.canEvaluateAdmissions) return false;
      if(item.id == 4 && !this.currentUser.privileges.canUnlockConfirmation) return false;
      
      // can only lock if next is unlocked and status is currentElement
      return  (this.admission_details.status < 5) && this.admission_details.unlock_for_next && item.id == this.admission_details.status;
    },

    saveResponse(response){
      switch(response.step){
        case 1: this.admission_id = response.value.id;
                this.is_editing = true;
                this.getAdmissionDetails();
                break;
        case 2: this.getAdmissionDetails();
                break;
        case 3: this.getAdmissionDetails();
                break;
        case 4: this.getAdmissionDetails();
                var tab = this.items.find((tab) => tab.id == 4)
                tab.is_form_valid = false;  
                break;
        case 5: this.getAdmissionDetails();
                break;
      }
      // console.log(response);
      // this.getAdmissionDetails();
    },

    formChange(form){
      this.items.find(step => { return step.id == form.step }).is_form_valid = form.is_valid;
    },  

    async getAdmissionDetails() {
      var url = endpoints.admissions + `${this.admission_id}/`;
      this.admission_details = await api.call(this.apiEssentials, url);
    },

    async unlockNext(){
      var url = endpoints.admissions + "unlock/";
      var post_body = {
        admission_ids: [this.admission_details.id],
      };
      var response = await api.call(
        this.apiEssentials,
        url,
        api.Methods.POST,
        post_body,
      )
      if (response instanceof Error){
        this.setLoading(false);
        this.snackbar.text = "Error unlocking";
        this.snackbar.visible = true;
        return;
      }
      // Avoid redudant navigation
      // this.$router.push({name: 'EditAdmissionDetails', params: { admission_id: this.admission_details.id }});
      this.admission_details.unlock_for_next = true;
      this.currentElement++; 
    },

    async lockNext(){
      var url = endpoints.admissions + "lock/";
      var post_body = {
        admission_ids: [this.admission_details.id],
      };
      var response = await api.call(
        this.apiEssentials,
        url,
        api.Methods.POST,
        post_body,
      )
      if (response instanceof Error){
        this.setLoading(false);
        this.snackbar.text = "Error locking";
        this.snackbar.visible = true;
        return;
      }
      // this.$router.push({name: 'EditAdmissionDetails', params: { admission_id: this.admission_details.id }});
      this.admission_details.unlock_for_next = false;
      
    },

    async showTerminateDialog() {
      this.showTerminateConfirmation = true;
    },

    async showRestoreDialog() {
      this.showRestoreConfirmation = true;
    },

    async terminateAdmissionConfirmation(confirm) {
      this.showTerminateConfirmation = false;
      // var admission_id = this.admission_id;
      var url = endpoints.admissions + "termination/";
      var post_body = {
        admission_ids: [this.admission_id],
      };
      if (confirm) {
          var response = await api.call(
          this.apiEssentials,
          url,
          api.Methods.POST,
          post_body,
        );
        if (response) {
          this.$router.push({ name: "Admissions" });
        }
      }
    },

    // async saveEnquiry(){
    //   post_body = {
    //     enquiry_details : this.admission_details.
    //   }
    // },

    async restoreAdmissionConfirmation(confirm) {
      this.showRestoreConfirmation = false;
      // var admission_id = this.$route.params.admission_id;
      var url = endpoints.admissions + "termination/restore/";
      var post_body = {
        admission_ids: [this.admission_id],
      };
      if (confirm) {
          var response = await api.call(
          this.apiEssentials,
          url,
          api.Methods.POST,
          post_body
        );
        if (response) {
          // this.admission_details.is_terminated = false;
          this.getAdmissionDetails();
        }
      }
    },

    async getDocTypes() {
      var url = endpoints.admissions + "get/doctypes/";
      this.doctypes = await api.call(this.apiEssentials, url);
    },

    async getClassStandards() {
      var url = endpoints.admissions + "get/class/standards/";
      this.class_standards = await api.call(this.apiEssentials, url);
    },

    async getEnquirySources(){
      this.enquirySources = await api.call(this.apiEssentials, endpoints.enquirySources)
    },


    // handles api errors
    async handleApiErrors(err) {
      this.setLoading(false);
      if (err.response) {
        console.log(err.response);
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.visible = true;
      }
    },

    onInput(val) {
      this.steps = parseInt(val);
    },
    // nextStep(n) {
    //   if (n === this.steps) {
    //     this.currentElement = 1;
    //   } else {
    //     this.currentElement = n + 1;
    //   }
    // },
    findNextItemTabName(item) {
      return this.items[item.id % 5].tab;
    },
  },
  watch: {
    steps(val) {
      if (this.currentElement > val) {
        this.currentElement = val;
      }
    },
    vertical() {
      this.currentElement = 2;
      requestAnimationFrame(() => (this.currentElement = 1)); // Workarounds
    },
  },
  async created() {
    if (this.$route.params.admission_id){
      this.is_editing = true;
      this.admission_id = this.$route.params.admission_id;
      await this.getAdmissionDetails();
      this.currentElement = this.admission_details.status;
    }
    this.getDocTypes();
    this.getClassStandards();
    this.getEnquirySources();

  },
};
</script>